import React from 'react';
import SimpleBarChart from '../Graficos/SimpleBarChart';
import Typography from '@material-ui/core/Typography';
import {get,range} from 'lodash-es';

export default function GraficoAno (props) {
  const { dados={} } = props;
  let { data, ano, attr, attrKey, modif=x=>x } = dados;
  data = get(data, ano);
  data = range(1,13).map(mes => get(data, mes))
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "600px",
      height: "400px"
    }}>
      {/* <Typography variant="display2">Encargos</Typography> */}
      <Typography variant="display1">{attr} ({ano})</Typography>
      <SimpleBarChart 
        data={data}
        dataKeys={[ [attr, attrKey ] ]}
        modif={modif}
      />
    </div>
  )
}
